import { useDispatch, useSelector } from 'react-redux'
import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import { useSnackbar } from 'baseui/snackbar'
import { selectContactConfig } from '../SubscriptionFormSelectors'
import { useTranslation } from 'react-i18next'

const useContact = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { enqueue } = useSnackbar()
  const saveContact = () => {
    dispatch({
      type: subscriptionFormActionsV2.CONTACT_MODULE_SAVE_V2,
      enqueue,
    })
  }
  const { isSaving } = useSelector(selectContactConfig)

  return { saveContact, isSaving, t }
}

export default useContact
